import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError, retry } from 'rxjs/operators'
import { AuthService } from '../services/auth.service'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap'
import { CommonModalComponent } from '../voucher-portal/shared/common-modal/common-modal.component'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, public modal: NgbModal) { }

  prevModal:any
  error: any
  errorModal: any = true
  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false
  };

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let errorMessage = ''
    return next.handle(request).pipe(
      retry(1),
      catchError((err: HttpErrorResponse) => {
        console.log('err check', err)
        if(err?.error?.error?.details) {
          this.error = err?.error?.error?.message +" "+ err?.error?.error?.details
        }
        else {
          this.error = err?.error?.error?.message ? err?.error?.error?.message : err?.error?.message;
        }
        
        this.errorPopup()
        if (err.status === 403 && !window.location.href.includes('/login')) {
          // auto logout if 401 response returned from api
          this.authService.logout()
          location.reload()
        } else if (err.error) {
          errorMessage = `Error Message: ${err.message}`
        }
        // const error = err.error.error || err.error.message || err.statusText;
        return throwError(err)
      }),
    )
  }

  errorPopup() {
    this.prevModal?.close()
    const modalRef = this.modal.open(CommonModalComponent, this.ngbModalOptions)
    modalRef.componentInstance.errorModal = this.errorModal
    modalRef.componentInstance.error = this.error
    this.prevModal=modalRef
  }
}
